import React, { useState } from 'react';
import Popover from '@material-ui/core/Popover';
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';
import { withStyles, IconButton } from '@material-ui/core';
import { postData } from '../../../../../../../api/componentAPIs';
import MobileOffIcon from '@material-ui/icons/MobileOff';
import { compose } from 'recompose';
import { withSnackbar } from 'notistack';
import Divider from '@material-ui/core/Divider';
import StyledToolTip from '../../../../../../common/StyledToolTip';

const styles = (theme) => ({
  paper: {
    padding: '16px 24px',
    backgroundColor: theme.ModalBGColor
  },
  headerStyle: {
    color: theme.chatMetadataColor,
    fontSize: theme.textFontSize,
    fontWeight: 500,
    textTransform: 'capitalize'
  },
  valueStyle: {
    color: theme.dispatchPanelLabelValueColor,
    fontSize: theme.headerTextFontSize,
    fontWeight: 500,
    paddingBottom: 12
  },
  buttonStyle: {
    color: theme.error,
    fontSize: theme.headerTextFontSize,
    fontWeight: 400,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    paddingTop: 12,
    justifyContent: 'center'
  },
  divider: {
    backgroundColor: theme.AppBGColor
  },
  phoneIcon: {
    color: theme.iconColor
  }
});

const InfoRow = withStyles(styles)(({ header, value, classes }) => (
  <>
    <div className={classes.headerStyle}>{header}</div>
    <div className={classes.valueStyle}>{value || '-'}</div>
  </>
));

const DriverAppInfo = ({ classes, driverInfo, userData, enqueueSnackbar }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleForceLogout = () => {
    postData('ForceDriverLogout', {
      driverId: driverInfo.driverId,
      terminalCode: userData.userProfile.terminal.code
    })
      .then((response) => {
        if (response && response.status >= 200 && response.status < 400) {
          enqueueSnackbar(`Force logout request sent to the driver ${driverInfo.driverName}`, {
            variant: 'success'
          });
          handleClose();
        } else {
          handleError(response);
        }
      })
      .catch((error) => {
        handleError(error);
      });
  };

  const handleError = (response) => {
    const errorMessage = response?.response?.data?.error?.message || response?.message;
    enqueueSnackbar(errorMessage || 'An error occurred while forcing logout.', {
      variant: 'error'
    });
    handleClose();
  };

  return (
    <div>
      <IconButton aria-label="device-details" className={classes.phoneIcon} onClick={handleClick}>
        <StyledToolTip title='Device Info'>
          <PhoneAndroidIcon aria-describedby={'phone-icon'} onClick={handleClick} />
        </StyledToolTip>
      </IconButton>

      <Popover
        id={'device-details'}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        classes={{ paper: classes.paper }}>
        <InfoRow header="Driver App Version" value={driverInfo.driverAppVersion} />
        <InfoRow header="Device Model" value={driverInfo.deviceModel} />
        <Divider className={classes.divider} />
        <div onClick={handleForceLogout} className={classes.buttonStyle}>
          <MobileOffIcon /> Force Logout
        </div>
      </Popover>
    </div>
  );
};

export default compose(withStyles(styles), withSnackbar)(DriverAppInfo);
